export default "__VITE_ASSET__6c5abfa2__"